import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../../services/apirest";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography,
  Stack,
  Grid,
  TextField,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import moment from "moment";

//Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Romaneo_administrar_parahabilitar() {
  const [romaneo_envases, setRomaneo_envases] = useState();
  const [fecha, setFecha] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
  );

  const [datosRomaneoEnvases, setDatosRomaneoEnvases] = useState({
    id_tipo_reparacion: null,
    id_tipo: null,
    nro_envase: null,
    id_mat_fabricante: null,
    lote: "",
    fecha_fabricacion: "",
    placa_relieve: 2,
    nro_placa: null,
    id_mot_baja: null,
    fecha_reparacion: "",
    id_pertenencia: null,
    fecha_habilitacion: fecha,
    hora_habilitacion: "",
    usuario: localStorage.getItem("user"),
  });

  const [tabla, setTabla] = useState(true);
  const [update, setUpdate] = useState(false);

  //MANEJA TAB
  const [opcion, setOpcion] = React.useState("para habilitar");

  const handleChange = (event, newValue) => {
    setOpcion(newValue);
  };

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  //funcion para obtener a los romaneo leyendas, pasarlos a json y guardarlos en data
  const obtenerRomaneoEnvases = () => {
    fetch(UrlApi + "/romaneo_envases/parahabilitar")
      .then((data) => data.json())
      .then((data) => setRomaneo_envases(data));
  };

  // ---------------------------------------------------------------

  //funcion que espera los cambios de la funcion de obtener a los romaneo leyendas
  useEffect(() => {
    obtenerRomaneoEnvases();
  }, [tabla]);

  // FUNCION QUE SE EJECUTA CADA VEZ QUE HAY UN CAMBIO EN LA BASE DE DATOS
  // SIRVE PARA QUE LA TABLA MOSTRADA SE ACTUALICE EN TIEMPO REAL
  useEffect(() => {
    if (update) obtenerRomaneoEnvases();
  }, [update]);

  //*************************************************************************************************************************************/

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  //*************************************************************************************************************************************/

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setUpdate(false);
  };

  //*************************************************************************************************************************************/

  const columns = useMemo(
    () => [
      {
        header: "Reparación",
        accessorKey: "descripcion_reparacion",
        size: 110,
      },
      {
        header: "Tipo de Envase",
        accessorKey: "descripcion_tipo_envase",
        size: 153,
      },
      { header: "N°.Envase", accessorKey: "nro_envase", size: 100 },
      { header: "N°.Acuñado", accessorKey: "nro_acuniado", size: 109 },
      {
        header: "Fabricante",
        accessorKey: "descripcion_fabricante",
        size: 105,
      },
      {
        header: "Fe.Rep.",
        accessorKey: "fecha_reparacion",
        size: 85,
        type: "date",
        format: "DD-MM-YYYY",
      },
      { header: "Leyenda", accessorKey: "leyenda", size: 130 },
      { header: "Firma", accessorKey: "firma", size: 120 },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    // para el buscar
    placeholder: "Buscar...",
    sx: { minWidth: "18rem" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  //**********************************************************************************************/

  const almacenar = (e) => {
    setDatosRomaneoEnvases({
      ...datosRomaneoEnvases,
      [e.target.name]: e.target.value,
    });
  };

  //*************************************************************************************************************************************/

  // ESTILO PARA LA TABLA
  const globalTheme = useTheme();

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
        sx: {
          fontSize: 14,
          fontStyle: "italic",
        },
      },
      size: 100,
    },
  };

  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 2000 },
  };

  const [activarDialog, setActivarDialog] = useState(false);
  const handleDesactivarDialog = () => {
    setActivarDialog(false);
  };

  return (
    <>
      <Container maxWidth="xl" mt={1}>
        {romaneo_envases && tabla ? (
          <Box mt={7.4} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                displayColumnDefOptions={displayColumnDefOptions}
                layoutMode="grid"
                muiTableHeadCellProps={{
                  align: "left", // los titulos de la tabla
                }}
                muiTableBodyCellProps={{
                  align: "left", //el contenido de la tabla
                }}
                localization={MRT_Localization_ES} //idioma
                initialState={initialState}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={romaneo_envases} //con lo q la completas (esto cambia siempre)
                // TRUE
                enableStickyFooter
                enableRowVirtualization
                enableGrouping // para permitir agrupar x estado x ej
                enableRowSelection
                enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
                // FALSE
                enableColumnDragging={false} //para arrastrar columnas
                enableColumnFilters={false} //desactiva filtros x  columna
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableDensityToggle={false}
                muiTableBodyRowProps={({ table, row }) => {
                  const rowIndex = table
                    .getRowModel() //  Obtengo todas las filas visibles en el orden actual
                    .rows.findIndex((r) => r.id === row.id); // Busca el índice real de la fila en la tabla
                  return {
                    sx: {
                      backgroundColor:
                        rowIndex % 2 === 0 ? "#ffffff" : "#f0f0f0", // Alternar los colores, incluso si hay agrupaciones o filtrados
                    },
                  };
                }}
                positionActionsColumn="last" // posicion de la columna de acciones al final
                renderTopToolbarCustomActions={({ table }) => {
                  const handleActivarDialog = () => {
                    setActivarDialog(true);
                  };
                  const handleActivar = () => {
                    table.getSelectedRowModel().flatRows.map((row) => {
                      // ACTIVAR RELACION
                      const guardarHabilitar = async () => {
                        console.log("Estoy por guardar");
                        await fetch(
                          UrlApi + "/romaneo_envases/" + row.original.id_envase,
                          {
                            method: "PUT",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                              id_estado: 152,
                              fecha_habilitacion:
                                datosRomaneoEnvases.fecha_habilitacion,
                            }),
                          }
                        )
                          .then((res) => {
                            if (!res.err) {
                              setOpenSnack(true);
                              setColorMensaje("#D4EFDF");
                              setMensaje("El envase se habilitó exitosamente!");
                              setUpdate(true);
                              setActivarDialog(false);
                            } else {
                              setOpenSnack(false);
                              setColorMensaje("#F1948A");
                              setMensaje("Error al habilitar");
                            }
                          })
                          .catch((err) => {
                            console.log(err.message);
                          });
                      };
                      guardarHabilitar();
                    });
                  };

                  return (
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <Typography variant="poster" fontSize={26}>
                        <span style={{ color: "#247af2" }}>
                          <b>Administrar</b>{" "}
                        </span>
                        Envases para Habilitar
                      </Typography>
                      <Button
                        color="success"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        // ACTIVAR
                        onClick={handleActivarDialog}
                        variant="contained"
                        size="small"
                      >
                        Rehabilitar
                      </Button>

                      <Dialog open={activarDialog} fullWidth>
                        <DialogTitle marginLeft={3}>
                          <b>{"Rehabilitar Envases"}</b>
                        </DialogTitle>

                        <DialogContent>
                          <Container maxWidth="xl">
                            <DialogContentText>
                              <b>Fecha:</b>
                            </DialogContentText>
                            <Grid item xs={5} mb={2}>
                              <TextField
                                style={style}
                                focused
                                size="small"
                                type="date"
                                name="fecha_habilitacion"
                                variant="outlined"
                                value={moment(
                                  datosRomaneoEnvases.fecha_habilitacion
                                ).format("YYYY-MM-DD")}
                                onChange={almacenar}
                              />
                            </Grid>

                            <Stack direction="row">
                              <Grid
                                container
                                direction={{ xs: "column", sm: "row" }}
                              >
                                <Grid item xs={8}>
                                  <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleDesactivarDialog}
                                  >
                                    Cancelar
                                  </Button>
                                </Grid>
                                <Grid item xs={4}>
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    color="success"
                                    onClick={handleActivar}
                                  >
                                    Rehabilitar
                                  </Button>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Container>
                        </DialogContent>
                      </Dialog>
                    </div>
                  );
                }}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>

      {/* SNACKBAR QUE SE MOSTRARA AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Romaneo_administrar_parahabilitar;
